<template lang="html">
    <div class="me-index">
        <van-card class="user-card">
            <template #desc>
                <div class="course-desc">
                    <van-swipe :autoplay="3000">
                        <van-swipe-item v-for="(item,index) in coverUrlArray" :key="index">
                            <img :src="item" style="width: 100%;max-height: 5rem;">
                        </van-swipe-item>
                    </van-swipe>
                    <div style="padding: 0.26667rem 0.42667rem;">
                        <h5 style="font-size: .45rem; margin: 0; font-weight: bold; ">{{ courseData.name }}</h5>
                        <!--                        <div style="padding: 10px 0; color: #1118;">-->
                        <!--                            <span class="divider-tag divider-right">{{ courseData.lessonDate }}</span>-->
                        <!--                            <span class="divider-tag divider-right">共{{courseData.lessonSize}}节</span>-->
                        <!--                            <span class="divider-tag ">45人已报名</span>-->
                        <!--                        </div>-->
                        <div>
                            <span style="color: #F53F05; font-size:0.55rem; margin-right: 10px; ">¥{{ courseData.registrationAmount }}</span>
                            <span style="color: #3339; font-size:0.35rem;text-decoration: line-through; ">¥{{ courseData.crossedAmount }}</span>
                        </div>
                        <div>
                            <span style="color: #3339; font-size:0.35rem; margin-right: 10px; ">关注服务号 &nbsp;</span>
                            <a style="color: #409EFF; font-size:0.45rem;"
                               href='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU3MzQ5MjE5MA==#wechat_redirect'>厦国会教务处服务号</a>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <van-tabs @click="onClick" sticky title-active-color="#0091AC" swipeable animated background="#F5F6F7">
                    <van-tab title="课程详情" title-style="font-size:.4rem;">
                      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <div style="padding: 0rem 0.42667rem;">
                                <van-sidebar v-model="activeKey" style="width: 100%;" class="custom-subtitle">
                                    <van-sidebar-item title="课程详情"/>
                                </van-sidebar>
                                <div style="text-align: left;  font-size: .4rem;">
                                    <p v-html="courseData.content"></p>
                                </div>

                        </div>
                      <div style="background-color: #fff;  margin-bottom: 50px;" v-if="recommendData && recommendData.length > 0">
                        <van-cell title-style="text-align:left;font-weight:bold;font-size:16px;"  title="相关推荐"  >
                        </van-cell>
                        <van-grid :column-num="2" :border="false" >
                          <van-grid-item  v-for="(item) in recommendData" class="course-item" :key="item.id"  @click="change2Link(item.link)">
                            <van-image fit="fill" :src="item.picLink"  class="coure-item-image"/>
                            <van-cell style="padding: 0px;" :value="item.title && getLength(item.title) > 20 ? subCHString(item.title,20) : item.title" />
                          </van-grid-item>
                        </van-grid>
                      </div>
                      </van-pull-refresh>
                    </van-tab>
                </van-tabs>
            </template>
        </van-card>
        <div style="height: 1.5rem;"></div>
        <van-goods-action v-if="courseData.teachingMethod === '4'" style="">
            <van-goods-action-icon style="min-width:3rem;" @click="showQrCode" v-if="recommendInfo.name"
                                   :icon="require('@/assets/consultant.png')" text="联系顾问"/>
            <van-goods-action-button
                    type="danger"
                    text="立即购买"
                    @click="buyCourse"
            />
        </van-goods-action>
        <van-goods-action v-else-if="courseData.teachingMethod === '2' || courseData.teachingMethod === '3'" style="">
          <van-goods-action-icon style="min-width:3rem;" @click="showQrCode" v-if="recommendInfo.name"
                                 :icon="require('@/assets/consultant.png')" text="联系顾问"/>
          <van-goods-action-button v-if="!isEnd && isStart"
              type="danger"
              text="'进入直播'"
              @click="enterLive"
          />
          <van-goods-action-button v-else-if="!isEnd && !isStart"
              type="danger"
              text="预约直播课"
              :to="{ path: `/wechat/course/1/apply?courseId=${courseId}&recommendId=${recommendId}&recommendType=${recommendType}`}"
          />
          <van-goods-action-button v-else-if="isEnd"
                                   type="danger"
                                   text="已结束"
          />
        </van-goods-action>
        <van-goods-action v-else style="">
            <van-goods-action-icon style="min-width:3rem;" @click="isShowQrCode=true" v-if="recommendInfo.name"
                                   :icon="require('@/assets/consultant.png')" text="联系顾问"/>
            <van-goods-action-button
                    type="danger"
                    text="报名参加"
                    :to="{ path: `/wechat/course/1/apply?courseId=${courseId}&recommendId=${recommendId}&recommendType=${recommendType}`}"
            />
        </van-goods-action>
        <van-popup v-model="isShowQrCode" round closeable>
            <van-image v-if="recommendInfo.wechatQrcode !== ''"
                       :src="recommendInfo.wechatQrcode"
            />
        </van-popup>
      <Overlay :show="show" @click="show = false">
        <div class="wrapper" >
          <span style="font-size: 20px; margin-top: 5px; margin-bottom: 5px;color: white;">请先关注公众号</span>
          <img src="http://jwc.xnai.edu.cn/files/upload/20220401/74a1ebd023b2737ec04600db45c2022c.png">
        </div>
      </Overlay>
    </div>
</template>


<style>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>

<script>
    import website from "../../utils/website";
    import wx from "weixin-js-sdk";
    import { Overlay } from 'vant';
    import {getOpenId, setOpenId, setToken} from "../../utils/auth";

    export default {
        components:{
          Overlay,
        },
        data() {
            return {
                openid: '',
                list: [],
                courseData: {},
                loading: false,
                finished: false,
                isLoading: false,
                show: false,
                isEnd: false,
                isStart: false,
                isReservation: false,
                user: {},
                courseId: '',
                recommendId: '',
                recommendType: '',
                isShowQrCode: false,
                recommendInfo: {},
                searchKey: "",
                activeKey: 0,
                activeName: 0,
                coverUrlArray: [],
                commentData: [],
                commendData: [],
                recommendData: []
            }
        },
        mounted() {
          this.getUserOpenId();
          this.init();
          this.getRecommendInfo();
          this.getCourseRecommend();
        },
      watch:{
          "courseData": {
            handler: function(val){
              if (!val.id || val.id === ''){
                return;
              }
              this.$api.course.isStart({
                courseId: val.id
              }).then((res) => {
                if (res.success){
                  this.isStart = res.data;
                }
              })
              this.$api.course.isEnd({
                courseId: val.id
              }).then((res) => {
                if (res.success){
                  this.isEnd = res.data;
                }
              })
              if (this.openid){
                this.$api.course.isReservationCourse({
                  courseId: val.id,
                  openId: this.openid
                }).then((res) => {
                  if (res.success){
                    this.isReservation = res.data;
                  }
                })
              }
            },
            immediate: true
          }
      },
        methods: {
          getUserOpenId(){
            this.openid = getOpenId();
            if (!(this.openid === 'undefined' || !this.openid)){
              this.getWechatUserToken(this.openid);
              return;
            }
            const code = window.localStorage.getItem('code')
            if (code){
              const params = {
                code: code,
                appid: website.appid
              };
              this.getWechatUser(params);
            } else {
              const fullPath = website.domain + this.$route.fullPath;
              const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${website.appid}&redirect_uri=${fullPath}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
              this.change2Link(url);
            }
          },
          getWechatUser(params){
            this.$api.wechat.getWxUserOpenId(params).then((res) => {
              if (res && res.code === 200){
                this.openid = res.msg;
                setOpenId(this.openid);
                this.getWechatUserToken(this.openid);
                window.localStorage.removeItem('code');
              } else if (res.code === 400){
                const fullPath = website.domain + this.$route.fullPath;
                const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${website.appid}&redirect_uri=${fullPath}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
                this.change2Link(url);
              }
            });
          },
          getWechatUserToken(openId){
            this.$api.wechat.getToken({
              grant_type: 'wechat',
              tenantId: '000000',
              openid: openId
            }).then((res) => {
              if (res.access_token){
                window.localStorage.removeItem('code');
                setToken(res.access_token);
                window.localStorage.setItem('user', JSON.stringify(res))
              }
            })
          },
          change2Link(link){
            window.location.href = link;
          },
          getCourseRecommend(){
            this.$api.course.getCourseRecommend({
              publishId: this.courseId
            }).then((res) => {
              if (res.code === 200) {
                this.recommendData = res.data;
              }
            })
          },
          showQrCode(){
            console.log('显示顾问信息名片：', this.recommendInfo)
            this.isShowQrCode = true;
          },
            init() {
                this.user = window.localStorage.getItem('user');
                if (this.user) {
                    this.user = JSON.parse(this.user);
                }
                const that = this;
                const courseId = this.$router.history.current.params.id;
                this.courseId = courseId;
                this.recommendId = this.$router.history.current.query.recommendId;
                this.recommendType = this.$router.history.current.query.recommendType;
                if (!this.recommendId && !this.recommendType && this.user) {
                    this.recommendId = this.user.user_id;
                    this.recommendType = window.localStorage.getItem('roleName');
                    this.getRecommendInfo();
                }
                this.$api.course.getPublishCourseDetail({
                    id: courseId
                }).then((res) => {
                    if (res.code === 200) {
                      that.courseData = res.data;
                      console.log('course data:', that.courseData)
                      window.document.title = this.courseData.name;
                        if (that.courseData.teachingMethod === '2' || that.courseData.teachingMethod === '3'){
                        that.show = true;
                      }
                      if (res.data.coverUrl.indexOf(',') > 0){
                        that.coverUrlArray = res.data.coverUrl.split(',');
                        that.share();
                      }
                    } else {
                      that.$notify({type: 'danger', message: res.msg})
                    }
                })
            },
          // 获取推荐人信息
          getRecommendInfo(){
            if (this.recommendType === '' || this.recommendId === ''){
              return;
            }
            if (this.recommendType === 'teacher') {
              this.$api.teacher.getTeacherInfo({
                userId: this.recommendId
              }).then((res) => {
                if (res.code === 200) {
                  this.recommendInfo = res.data;
                  this.recommendId = this.recommendInfo.id;
                }
              })
            } else{
              const that = this;
              this.$api.consultant.getConsultantInfo({
                userId: that.recommendId
              }).then((res) => {
                console.log('consultantInfo ',res);
                if (res.code === 200){
                  that.recommendInfo = res.data;
                  this.recommendId = this.recommendInfo.id;
                } else if (res.code === 400){
                  this.$api.consultant.getConsultantInfo({
                    id: that.recommendId
                  }).then((res) => {
                    if (res.code === 200){
                      that.recommendInfo = res.data;
                      this.recommendId = this.recommendInfo.id;
                    }
                  })
                }
              })
            }
          },
          share(){
            const that = this;
            this.isLoading = true;
            const shareUserUrl = website.domain + `/wechat/openCourse/${this.courseId}?recommendId=${this.recommendId}&recommendType=${this.recommendType}`;
            this.$api.wechat.getShareSignature({
              appid: website.appid,
              shareUrl: website.domain + this.$route.fullPath,
            }).then((res) => {
              this.isLoading = false;
              const shareSign = res.data;
              wx.config({
                debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: shareSign.appId,         // 必填，公众号的唯一标识，填自己的！
                timestamp: shareSign.wxTimestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: shareSign.wxNoncestr,   // 必填，生成签名的随机串
                signature: shareSign.wxSignature, // 必填，签名，见附录1
                jsApiList: [
                  'updateAppMessageShareData',
                  'updateTimelineShareData',
                ]
              })
              wx.checkJsApi({
                jsApiList: ['chooseImage','updateAppMessageShareData','updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                  console.log('check jsapi res: ', res);
                }
              });
              const userName = that.user ? that.user.nick_name : '';
              wx.ready(function () {
                //分享到朋友圈
                wx.updateTimelineShareData({
                  title: '【' + that.courseData.categoryName + '】' + that.courseData.name,   // 分享时的标题
                  link: shareUserUrl,     // 分享时的链接
                  imgUrl: that.courseData.thumbUrl,    // 分享时的图标
                  success: function () {
                    // that.$notify({type:'success',message:'分享朋友圈配置成功'});
                    // that.$api.consultant.saveShareCount({consultantId: that.consultantInfo.id})
                  },
                  fail: function (res) {
                    console.log('注册消息分享到朋友圈失败：',res)
                    // that.$notify({type: 'warning', message: '取消分享' });
                  }
                });
                //分享给朋友
                wx.updateAppMessageShareData({
                  title:  `【${that.courseData.categoryName}】${that.courseData.name}`,   // 分享时的标题
                  link: shareUserUrl,     // 分享时的链接
                  imgUrl: that.courseData.thumbUrl,    // 分享时的图标
                  desc: `${userName}向您推荐优秀课程`,
                  success: function () {
                    // that.$notify({type:'success',message:'分享朋友配置成功'});
                    // that.$api.consultant.saveShareCount({consultantId: that.consultantInfo.id})
                  },
                  fail: function (res) {
                    console.log('注册分享给朋友失败：',res)
                    // that.$notify({type: 'warning', message: '取消分享' });
                  }
                });
              })
              wx.error(function (res){
                console.log('wx error  ', res)
              })
            })
          },
            onRefresh() {
                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            },
            onClick(name, title) {
                switch (title) {
                    case '目录':
                        this.getCourseLessonList();
                        break;
                }
            },
            buyCourse() {
                window.location.href = this.courseData.courseLink;
            },
            enterLive(){
              window.location.href = this.courseData.courseLink;
            },
            getCourseLessonList() {
                this.$api.course.getPublishCourseLessonDetail({
                    id: this.courseId
                }).then((res) => {
                    if (res.code === 200) {
                        this.list = res.data
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1)
                    }
                    // 加载状态结束
                    this.loading = false
                    // 数据全部加载完成
                    if (this.list.length >= 10) {
                        this.finished = true
                    }
                }, 100)
            },
          getLength(str) {
            ///<summary>获得字符串实际长度，中文2，英文1</summary>
            ///<param name="str">要获得长度的字符串</param>
            var realLength = 0, len = str.length, charCode = -1;
            for (var i = 0; i < len; i++) {
              charCode = str.charCodeAt(i);
              if (charCode >= 0 && charCode <= 128) realLength += 1;
              else realLength += 2;
            }
            return realLength;
          },
          subCHString(str, len) {
            var str_length = 0;
            var str_len = 0;
            let str_cut = new String();
            str_len = str.length;
            for (var i = 0; i < str_len; i++) {
              let a = str.charAt(i);
              str_length++;
              if (escape(a).length > 4) {
                //中文字符的长度经编码之后大于4
                str_length++;
              }
              str_cut = str_cut.concat(a);
              if (str_length >= len) {
                str_cut = str_cut.concat("...");
                return str_cut;
              }
            }
            //如果给定字符串小于指定长度，则返回源字符串；
            if (str_length < len) {
              return str;
            }
          }
        }
    }
</script>

<style lang="less" scoped>

    .divider-tag {
        padding-right: 8px;
        margin-right: 8px;
        position: relative;
    }

    [class*='divider-right']::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border-right: 1px solid #aaa8;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
    }

    .user-card {
        padding: 0px;
        background: #fff;
    }

    .van-card__header {
    }

    .user-card .van-card__footer {
        text-align: left;
    }

    .user-card .van-card__thumb {
        width: 38%;
        max-width: 150px;
        height: auto;
    }

    .list-card {
        padding: 0;
        background: #fff;
    }


    .list-card .van-card__header {
        padding: 0px;
    }

    .list-card .van-card__thumb {
        width: 18vw;
        max-width: 150px;
        height: auto;
    }

    .course-info--ellipse {
        background-color: #fff;
        padding: 0;
    }

    .course-info--ellipse .van-card__thumb {
        width: 16vw;
        max-width: 150px;
        height: auto;
    }


    .videos-card {
        padding: 0;
        background: #fff;
    }

    .videos-card .van-card__header {
        padding: 0px;
    }

    .videos-card .van-card__thumb {
        width: 24vw;
        max-width: 150px;
        height: auto;
    }

    /*购物车按钮*/
    .van-goods-action-button--danger {
        background: -webkit-linear-gradient(left, #00b1d2, #0091AC);
        background: linear-gradient(to right, #00b1d2, #0091AC);
    }


    .van-card__footer .van-button {
        margin-left: 0;
    }

    .van-sidebar-item {
        padding: 0.5rem 0.32rem;
        font-size: 0.5rem;
    }

    .custom-collapse {
        text-align: center;
    }

    .custom-collapse-item {
        display: inline-block;
        color: #888;
    }


    #container {
        width: 100%;
        z-index: 1;
        min-height: 100vh;

        &:hover {
            cursor: pointer;
        }
    }

    .list-caontainer {
        margin-bottom: 1.2rem;
    }

    .search-icon {
        font-size: .3rem;
        line-height: inherit;
    }

    .van-card__content {
        min-height: 1rem;
    }
</style>
<style>
    .van-cell--clickable:active {
        background-color: #fff;
    }

    .custom-collapse-item .van-cell {
        width: fit-content;
        margin: 0 auto;
    }

    .custom-collapse-item .van-cell__title, .custom-collapse-item .van-cell__right-icon {
        color: #1114;
    }

    .custom-collapse-item .van-cell__right-icon {
    }

    .van-goods-action-icon__icon {
        font-size: 0.5rem;
    }

    .custom-subtitle {
        overflow-y: unset;
    }
</style>
